module.exports = __webpack_public_path__ + "static/media/lwss.4da2195d.png";